import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getAdvertsListCount } from '../thunks/commonInfoThunks';
import { getSearchListCount } from '../../search/searchThunks';

const SLICE_NAME = 'advertsCount';

const advertsCountInitialState = {
    data: null,
    searchResults: null,
    isLoading: false,
    error: null,
};

export const advertsCountSlice = createSlice({
    name: SLICE_NAME,
    initialState: advertsCountInitialState,
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getAdvertsListCount });
        builder
            .addCase(getSearchListCount.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getSearchListCount.fulfilled, (state, action) => {
                state.searchResults = action.payload;
                state.isLoading = false;
            })
            .addCase(getSearchListCount.rejected, (state, action) => {
                state.error = action.error.message;
                state.isLoading = false;
            });
    },
});

export const selectAdvertsCountLoading = (state) =>
    state.commonData.advertsCount.isLoading || false;

export const selectAdvertsCountTotal = (state) =>
    state.commonData.advertsCount?.data?.[0] || 0;

export const selectSearchResultsCountRaw = (state) =>
    state.commonData.advertsCount?.searchResults?.[0]?.searchResults;

export const selectSearchResultsCount = (state) =>
    selectSearchResultsCountRaw(state) || 0;

export const advertsCount = advertsCountSlice.reducer;
